export default __webpack_public_path__ + "static/media/210430-Cloudxier Clients Logo-17.11e6c262.png";